import React from "react";
import "../styles/index.scss";

export default function CheckboxIcon({
  isChecked = false,
  isIndeterminate = false,
  isDisabled = false,
}) {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isDisabled ? (
          <React.Fragment>
            <rect x="1" y="1" width="14" height="14" fill="white" />
            <rect
              x="1"
              y="1"
              width="14"
              height="14"
              stroke="lightgrey"
              strokeWidth="2"
            />
          </React.Fragment>
        ) : isIndeterminate ? (
          <React.Fragment>
            <rect width="16" height="16" fill="#0000F5" />
            <path
              d="M3.19995 7.19995H12.8V8.79995H3.19995V7.19995Z"
              fill="white"
            />
          </React.Fragment>
        ) : isChecked ? (
          <React.Fragment>
            <rect
              width="16"
              height="16"
              fill="#0000F5"
              className="checked-fill"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.3313 6.00002L11.1999 4.86865L6.39993 9.66864L4.39993 7.66863L3.26855 8.8L6.39993 11.9314L12.3313 6.00002Z"
              fill="white"
              className="checked-fill-2"
            />
            <rect
              x="1"
              y="1"
              width="14"
              height="14"
              stroke="#0000F5"
              strokeWidth="2"
              className="checked-stroke"
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <rect x="1" y="1" width="14" height="14" fill="white" />
            <rect
              x="1"
              y="1"
              width="14"
              height="14"
              stroke="#222222"
              strokeWidth="2"
              className="default-checkbox-stroke"
            />
          </React.Fragment>
        )}
      </svg>
    </React.Fragment>
  );
}
